import { css } from 'linaria';

export const price = css`
  height: 100%;
  color: var(--text-minor);
  padding: var(--space-100) 0;
`;
